import { wishlistNow } from './ksh-wishlist-calendar.js';
import { dates,gameDates,festiveState,countdownParts } from './ksh-festive-calendar.js';
const previewStart=wishlistNow(),realStart=Date.now();
const now=()=>previewStart+Date.now()-realStart;
const dialog=document.querySelector('[data-fireworks-dialog]');
const query=new URLSearchParams(location.search);
function update(){
 const time=now(),state=festiveState(time);
 for(const name of ['carnival','newyear'])document.documentElement.classList.toggle(`ksh-brand-${name}`,state.logo===name);
 document.querySelectorAll('[data-exclusive]').forEach(card=>{
  const [start,end]=gameDates[card.dataset.exclusive];
  card.hidden=time>=end;
  const link=card.querySelector('a'),status=card.querySelector('[data-game-status]');
  if(time>=start&&time<end){
   const url=new URL(link.dataset.seasonHref,location.origin);
   if(window.Shopify?.theme?.role==='unpublished'&&query.get('ksh_preview_date'))url.searchParams.set('ksh_preview_date',query.get('ksh_preview_date'));
   link.href=url.href;link.removeAttribute('aria-disabled');status.textContent=status.dataset.live;
  }else{link.removeAttribute('href');link.setAttribute('aria-disabled','true');status.textContent=status.dataset.soon;}
 });
 document.querySelectorAll('.kf-exclusive').forEach(group=>{group.hidden=![...group.querySelectorAll('[data-exclusive]')].some(el=>!el.hidden);});
 const banner=document.querySelector('[data-festive-banner]');
 if(banner){
  banner.hidden=!state.banner;
  if(state.banner){
   for(const selector of ['[data-banner-title]','[data-banner-date]']){const el=banner.querySelector(selector);el.textContent=el.dataset[state.banner];}
   const target=state.banner==='prince'?dates.reveal:dates.carnival;
   countdownParts(target,time).forEach((value,i)=>{banner.querySelectorAll('[data-festive-time]')[i].textContent=String(value).padStart(2,'0');});
   banner.querySelector('.kf-countdown').hidden=time>=target;
   banner.querySelector('[data-carnival-started]').hidden=time<target;
  }
 }
 document.querySelectorAll('[data-fireworks-promo]').forEach(el=>{el.hidden=!state.fireworks;});
 if(dialog?.open){
  dialog.querySelector('[data-fireworks-play]').hidden=!state.fireworks;
  dialog.querySelector('[data-fireworks-closed]').hidden=state.fireworks;
 }
}
update();let timer=setInterval(update,1000);
window.addEventListener('pagehide',()=>clearInterval(timer));
window.addEventListener('pageshow',e=>{if(e.persisted){clearInterval(timer);timer=setInterval(update,1000);update();}});
document.addEventListener('shopify:section:load',update);
if(dialog){
 const sky=dialog.querySelector('.kf-sky'),canvas=sky.querySelector('canvas'),ctx=canvas.getContext('2d');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const wish=dialog.querySelector('[data-firework-wish]'),again=dialog.querySelector('.kf-again'),counter=dialog.querySelector('[data-firework-count]');
 let count=0,particles=[],raf=0,last=0,width=0,height=0;
 const colors=['#ff920c','#59d43b','#ffad27','#76e35d','#ffd578','#a0dfef'];
 function resize(){const rect=sky.getBoundingClientRect(),scale=Math.min(devicePixelRatio||1,2);width=rect.width;height=rect.height;canvas.width=Math.round(width*scale);canvas.height=Math.round(height*scale);ctx?.setTransform(scale,0,0,scale,0,0);}
 function stop(){cancelAnimationFrame(raf);raf=0;particles=[];ctx?.clearRect(0,0,width,height);}
 function frame(t){
  if(!dialog.open||document.hidden){stop();return;}
  const dt=Math.min((t-last)/1000,.04);last=t;ctx.clearRect(0,0,width,height);
  particles=particles.filter(p=>p.life>0);
  for(const p of particles){p.life-=dt;p.x+=p.vx*dt;p.y+=p.vy*dt;p.vy+=45*dt;ctx.globalAlpha=Math.max(0,p.life/p.max);ctx.fillStyle=p.color;ctx.beginPath();ctx.arc(p.x,p.y,p.size,0,Math.PI*2);ctx.fill();}
  ctx.globalAlpha=1;
  if(particles.length)raf=requestAnimationFrame(frame);else raf=0;
 }
 function burst(x,y){
  if(!ctx)return;
  const color=colors[(count-1)%colors.length];
  for(let i=0;i<(reduced.matches?18:72);i++){
   const angle=Math.random()*Math.PI*2,speed=35+Math.random()*130,max=reduced.matches?.6:1.1+Math.random()*.8;
   particles.push({x:x+(reduced.matches?Math.cos(angle)*25:0),y:y+(reduced.matches?Math.sin(angle)*25:0),vx:reduced.matches?0:Math.cos(angle)*speed,vy:reduced.matches?0:Math.sin(angle)*speed,life:max,max,color:i%7===0?'#fff1bc':color,size:1+Math.random()*2});
  }
  particles=particles.slice(-720);
  if(!raf){last=performance.now();raf=requestAnimationFrame(frame);}
 }
 sky.addEventListener('click',e=>{
  if(!festiveState(now()).fireworks)return;
  count++;counter.textContent=String(Math.min(count,10));
  const rect=sky.getBoundingClientRect(),keyboard=e.detail===0;
  burst(keyboard?width*(.25+Math.random()*.5):e.clientX-rect.left,keyboard?height*(.25+Math.random()*.45):e.clientY-rect.top);
  if(count===10){wish.hidden=false;again.hidden=false;}
 });
 again.addEventListener('click',()=>{count=0;counter.textContent='0';wish.hidden=true;again.hidden=true;stop();sky.focus();});
 const observer=new ResizeObserver(resize);observer.observe(sky);
 dialog.addEventListener('close',stop);
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else update();});
 window.addEventListener('pagehide',()=>{stop();observer.disconnect();});
 window.addEventListener('pageshow',e=>{if(e.persisted)observer.observe(sky);});
 if(query.get('spel')==='vuurwerk'){
  document.querySelector('.ksh-welcome')?.setAttribute('hidden','');
  dialog.showModal();update();resize();
  if(festiveState(now()).fireworks)sky.focus();else dialog.querySelector('[data-fireworks-close]').focus();
 }
 const home=new URL(dialog.querySelector('[data-fireworks-close]').href);
 if(window.Shopify?.theme?.role==='unpublished'&&query.get('ksh_preview_date'))home.searchParams.set('ksh_preview_date',query.get('ksh_preview_date'));
 dialog.querySelector('[data-fireworks-close]').href=home.href;
 dialog.addEventListener('cancel',e=>{e.preventDefault();location.href=home.href;});
}
